var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('h4',[_vm._v(_vm._s(_vm.$t('Dashboard')))])])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }